import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { baseURL } from "../ApiConstant";

// get item list
export const getFSItemList = async (category: 'Light' | 'Bathroom') => {
    try {
        const formData = new FormData();
        formData.append("category", category);

        const response = await apiClient.post(`/api/fs-item-list`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// create Item
export const createFSItem = async (
    category: string,
    item_name: string,
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/fs-item/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ category, item_name }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update Item
export const updateFSItem = async (
    category: string,
    item_name: string,
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/fs-item/update/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ category, item_name }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

//  delete Item
export const deleteFSItem = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(
            `${baseURL}/api/fs-item/delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};